import React, {useEffect, useState} from 'react'
import {observer} from 'mobx-react-lite'
import {Container, Box, Stack} from '../../vanilla'
import {Breadcrumbs, Crumb} from '../../components/breadcrumbs'
import {SlotItem, SlotContentItem} from '../../types/cms'
import {ContentBody} from 'dc-delivery-sdk-js'
import {Seo} from '../../components/seo'
import {usePageDataTracking} from '../../analytics/page-tracking'
import {useCategoryStore} from '../../store/hooks/useStore'
import {getBottomSlot} from './partials/display-slots'
import { RetailMediaResponse } from '../../types/retail-media'
export interface CategoryPageProps {
  children: React.ReactNode
  slots?: SlotContentItem
  seo?: {
    pageTitle: string
    pageDescription: string
  }
  categoryId?: string
  name?: string
  categoryTree: Crumb[]
  productAds?: RetailMediaResponse
}

export interface SlotContentType extends ContentBody {
  default: SlotItem[]
}

const CategoryPage = observer(
  ({children, slots, seo, categoryId, categoryTree, name}: CategoryPageProps) => {
    
    const [bottomSlot, setBottomSlot] = useState(null)

    // Load slot when applicable
    useEffect(() => {
      if (slots) {
        setBottomSlot(getBottomSlot(slots))
      }
    }, [slots])

    const sendPageData = usePageDataTracking()

    let pageType = ''
    let pageCategory = ''
    let pageSubCategory = ''

    const {categories, status} = useCategoryStore()

    useEffect(() => {
      if (status !== 'done') {
        return
      }

      const category = categoryId && categoryId in categories ? categories[categoryId] : undefined
      if (category) {
        pageType = 'plp'
        const {isTopLevelCategory, parentCategoryTree, name} = category

        if (!isTopLevelCategory) {
          pageCategory = parentCategoryTree?.[0].name || ''
          pageSubCategory = name || ''
        } else {
          pageCategory = name || ''
        }
      }
      sendPageData(pageType, pageCategory, pageSubCategory)
    }, [status, categoryId])

    return (
      <Container position="relative" paddingX="0px" paddingBottom="60px">
        <Seo
          title={seo?.pageTitle || `${name} | Iceland Foods`}
          description={seo?.pageDescription}
        />
        <Container top="0px" paddingX="0px" position="relative">
          <Box paddingY="12px">
            <Breadcrumbs breadcrumbs={categoryTree} categoryId={categoryId} />
          </Box>
        </Container>
        <>
          {children}
          <Stack>
            {bottomSlot}
          </Stack>
        </>
      </Container>
    )
  },
)

export default CategoryPage
